import clamp from 'lodash/clamp';
import { searchBasePath } from './search-utils';

function getPageLimits(currentPage, totalPages, displayLimit = 9) {
  const halfDisplayLimit = Math.floor(displayLimit / 2);
  let startOffset = clamp(currentPage - halfDisplayLimit, 0, totalPages);
  let endOffset = clamp(currentPage + halfDisplayLimit, 0, totalPages);
  if (currentPage < halfDisplayLimit) {
    endOffset += halfDisplayLimit - currentPage;
  } else if (currentPage > totalPages - halfDisplayLimit) {
    startOffset -= totalPages - currentPage;
  }
  return { startOffset, endOffset };
}

function getSearchPagination(results, queryString) {
  if (!results || results.nbPages <= 1) return null;
  const { nbPages, page } = results;
  const { startOffset, endOffset } = getPageLimits(page, nbPages);
  return Array.from({ length: nbPages }, (value, index) => ({
    current: index === page,
    display: index <= endOffset && index >= startOffset,
    title: index + 1,
    url: `${searchBasePath}${queryString}`,
  }));
}

export { getPageLimits, getSearchPagination };
